
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ButtonFloatMenu from '@/components/organisms/manage/ButtonFloatMenu.vue'
import { AvatarCode } from '@/const/AvatarCode'
import { UserList } from '@/models/manage/UserList'

/**
 * ユーザ一覧テーブル
 */
@Component({
  components: {
    ImageBase,
    ButtonBase,
    ButtonFloatMenu,
  },
})
export default class UserListTable extends Vue {
  /** ユーザ一覧 */
  @Prop()
  private userList!: UserList[]

  /** 編集メニュー表示イベント */
  @Prop()
  private eventClickEditButton!: (event: Event, userId: number) => Promise<void>

  /**
   * 「教室」カラムの有無
   *
   * @returns 「教室」カラムがあればtrue
   */
  private get hasColumnBranch(): boolean {
    return !!this.$scopedSlots.headerBranch
  }

  /**
   * 「塾」カラムの有無
   *
   * @returns 「塾」カラムがあればtrue
   */
  private get hasColumnAcademy(): boolean {
    return !!this.$scopedSlots.headerAcademy
  }

  /**
   * アイコンコードからアイコン画像のパスを引き当てる
   *
   * @param code アイコンコード
   * @returns アイコン画像のパス
   */
  private iconUrl(code: string): string {
    const avatar = AvatarCode.findByCode(code)
    return avatar.path
  }
}
